module.exports = __webpack_public_path__ + "static/media/sticky_bun.1c1ac498.JPG";